import React from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button } from "reactstrap"

import OfferDetailsSection from "pages/admin/Offers/components/OfferDetailsSection"
import OfferPerformance from "pages/admin/Offers/components/OfferPerformance"
import { useTranslation } from "react-i18next"

const OfferDetails = () => {
  const { t } = useTranslation()
  const editOfferHandler = () => {}
  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("offers_offers")}
        />
        <Button
          onClick={editOfferHandler}
          color="success"
          className="bg-gradiant-blue text-capitalize border-0"
        >
          {t("offers_editOffer")}
        </Button>
      </div>
      <OfferDetailsSection />
      <OfferPerformance />
    </div>
  )
}

export default OfferDetails
